import {Routes} from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'router',
        pathMatch: 'full',
    },
    {
        path: 'router',
        loadComponent: () => import('./views/router.component').then(m => m.RouterComponent),
        canActivate: [],
        data: {
            title: 'Home'
        },
    },
    {
        path: 'data_entry',
        children: [
            {
                path: '',
                redirectTo: 'clients/list',
                pathMatch: 'full'
            },
            {
                path: 'clients',
                canActivate: [],
                data: {
                    title: 'Clients'
                },
                children: [
                    {
                        path: 'list',
                        loadComponent: () => import ('./views/clients.component').then(m => m.ClientsComponent),
                        canActivate: [],
                        data: {
                            title: 'Clients'
                        }
                    },
                    {
                        path: 'workload',
                        loadComponent: () => import ('./views/clients.component').then(m => m.ClientsComponent),
                        canActivate: [],
                        data: {
                            title: 'Workload'
                        }
                    },
                    {
                        path: ':clientId',
                        loadComponent: () => import ('./views/client-tab.component').then(m => m.ClientTab),
                        canActivate: [],
                        data: {
                            title: 'Client'
                        }
                    }
                ]
            },
            {
                path: 'assessments_batch_approve',
                loadComponent: () => import('./views/assessments/assessmentsBatchApprove.component')
                    .then(m => m.AssessmentsBatchApproveComponent),
                canActivate: [],
                data: {
                    title: 'Batch Approve Assessments'
                }
            },
            {
                path: 'assessments',
                canActivate: [],
                data: {
                    title: 'Assessments'
                },
                children: [
                    {
                        path: 'list',
                        loadComponent: () => import ('./views/assessments/assessmentsList.component').then(m => m.AssessmentsListComponent),
                        canActivate: [],
                        data: {
                            title: 'Assessments'
                        }
                    },
                    {
                        path: 'approve',
                        loadComponent: () => import ('./views/assessments/assessmentsList.component').then(m => m.AssessmentsListComponent),
                        canActivate: [],
                        data: {
                            title: 'Approve'
                        }
                    },
                    {
                        path: 'myInProgress',
                        loadComponent: () => import ('./views/assessments/assessmentsList.component').then(m => m.AssessmentsListComponent),
                        canActivate: [],
                        data: {
                            title: 'My In Progress'
                        }
                    },
                    {
                        path: 'myReturned',
                        loadComponent: () => import ('./views/assessments/assessmentsList.component').then(m => m.AssessmentsListComponent),
                        canActivate: [],
                        data: {
                            title: 'My Returned'
                        }
                    },
                    {
                        path: ':clientId?',
                        loadComponent: () => import ('./views/assessments/assessmentsList.component').then(m => m.AssessmentsListComponent),
                        canActivate: [],
                        data: {
                            title: 'Assessments'
                        }
                    },
                ]
            },
            {
                path: 'assessment',
                children: [
                    {
                        path: ':assessmentId',
                        loadComponent: () => import ('./views/assessments/assessment.component').then(m => m.Assessment),
                        children: [
                            {
                                path: 'approveSequential',
                                loadComponent: () => import ('./views/assessments/assessment.component').then(m => m.Assessment),
                                canActivate: [],
                                data: {
                                    title: 'Assessment'
                                }
                            }
                        ],
                        canActivate: [],
                        data: {
                            title: 'Assessment'
                        }
                    },
                    {
                        path: ':instrumentType/:clientId',
                        loadComponent: () => import ('./views/assessments/assessment.component').then(m => m.Assessment),
                        canActivate: [],
                        data: {
                            title: 'Assessment'
                        }
                    }
                ],
                canActivate: [],
                data: {
                    title: 'Assessment'
                }
            },
            {
                path: 'assessmentad',
                children: [
                    {
                        path: ':assessmentId',
                        loadComponent: () => import ('./views/assessments/adjunctive-assessment.component')
                            .then(m => m.AdjunctiveAssessment),
                        canActivate: [],
                        data: {
                            title: 'Adjunctive Assessment'
                        }
                    },
                    {
                        path: ':instrumentType/:clientId',
                        loadComponent: () => import ('./views/assessments/adjunctive-assessment.component')
                            .then(m => m.AdjunctiveAssessment),
                        canActivate: [],
                        data: {
                            title: 'Adjunctive Assessment'
                        }
                    }
                ],
                canActivate: [],
                data: {
                    title: 'Adjunctive Assessment'
                }
            },
            {
                path: 'assessmentpsc',
                children: [
                    {
                        path: ':assessmentId',
                        loadComponent: () => import ('./views/assessments/psc-assessment.component').then(m => m.PscAssessment),
                        canActivate: [],
                        data: {
                            title: 'PSC Assessment'
                        }
                    },
                    {
                        path: ':instrumentType/:clientId',
                        loadComponent: () => import ('./views/assessments/psc-assessment.component').then(m => m.PscAssessment),
                        canActivate: [],
                        data: {
                            title: 'PSC Assessment'
                        }
                    },
                    {
                        path: ':instrumentType/:clientId/:languageCode',
                        loadComponent: () => import ('./views/assessments/psc-assessment.component').then(m => m.PscAssessment),
                        canActivate: [],
                        data: {
                            title: 'PSC Assessment'
                        }
                    }
                ],
                canActivate: [],
                data: {
                    title: 'PSC Assessment'
                }
            },
            {
                path: 'assessmentc',
                children: [
                    {
                        path: ':assessmentId',
                        loadComponent: () => import ('./views/assessments/cans-assessment.component').then(m => m.CansAssessment),
                        canActivate: [],
                        data: {
                            title: 'CANS Assessment'
                        }
                    },
                    {
                        path: ':assessmentId/approveSequential',
                        loadComponent: () => import ('./views/assessments/cans-assessment.component').then(m => m.CansAssessment),
                        canActivate: [],
                        data: {
                            title: 'CANS Assessment'
                        }
                    },
                    {
                        path: ':assessmentId/:groupId',
                        loadComponent: () => import ('./views/assessments/cans-assessment.component').then(m => m.CansAssessment),
                        canActivate: [],
                        data: {
                            title: 'CANS Assessment'
                        }
                    },
                    {
                        path: ':assessmentId/:groupId/approveSequential',
                        loadComponent: () => import ('./views/assessments/cans-assessment.component').then(m => m.CansAssessment),
                        canActivate: [],
                        data: {
                            title: 'CANS Assessment'
                        }
                    },
                    {
                        path: ':instrumentType/:clientId/:createGroup',
                        loadComponent: () => import ('./views/assessments/cans-assessment.component').then(m => m.CansAssessment),
                        canActivate: [],
                        data: {
                            title: 'CANS Assessment'
                        }
                    },
                    {
                        path: ':instrumentType/:clientId/:createGroup/:languageCode',
                        loadComponent: () => import ('./views/assessments/cans-assessment.component').then(m => m.CansAssessment),
                        canActivate: [],
                        data: {
                            title: 'CANS Assessment'
                        },
                    }
                ],
                canActivate: [],
                data: {
                    title: 'CANS Assessment'
                }
            },
            {
                path: 'certifications',
                children: [
                    {
                        path: 'import',
                        loadComponent: () => import ('./views/certifications/certification-import.component')
                            .then(m => m.CertificationImportComponent),
                        canActivate: [],
                        data: {
                            title: 'Import Certification'
                        }
                    }
                ]
            },
            {
                path: 'data-profiles',
                loadComponent: () => import ('./views/data-profiles.component').then(m => m.DataProfilesComponent),
                canActivate: [],
                data: {
                    title: 'Data Profiles'
                }
            },
            {
                path: 'checklists',
                canActivate: [],
                data: {
                    title: 'Checklists'
                },
                children: [
                    {
                        path: ':checklistId',
                        loadComponent: () => import ('./views/checklists/checklist.component').then(m => m.ChecklistComponent),
                        canActivate: [],
                        data: {
                            title: 'Checklist'
                        },
                    }
                ]
            },
            {
                path: 'dashboard',
                children: [
                    {
                        path: 'clinician/my',
                        loadComponent: () => import ('./views/dashboards/clinician-dashboard.component')
                            .then(m => m.ClinicianDashboardComponent),
                        canActivate: [],
                        data: {
                            title: 'Clinician Dashboard'
                        }
                    },
                    {
                        path: 'clinician/:dashboardClinicianId',
                        loadComponent: () => import ('./views/dashboards/clinician-dashboard.component')
                            .then(m => m.ClinicianDashboardComponent),
                        canActivate: [],
                        data: {
                            title: 'Clinician Dashboard'
                        }
                    },
                    {
                        path: 'orgUnit',
                        loadComponent: () => import ('./views/dashboards/org-unit-dashboard.component')
                            .then(m => m.OrgUnitDashboardComponent),
                        canActivate: [],
                        data: {
                            title: 'Org Unit Dashboard'
                        }
                    },
                    {
                        path: 'supervisor',
                        loadComponent: () => import ('./views/dashboards/supervisorDashboard.component')
                            .then(m => m.SupervisorDashboardComponent),
                        canActivate: [],
                        data: {
                            title: 'Supervisor Dashboard'
                        }
                    },
                    {
                        path: 'modelOfCare',
                        loadComponent: () => import ('./views/dashboards/modelOfCareDashboard.component')
                            .then(m => m.ModelOfCareDashboardComponent),
                        canActivate: [],
                        data: {
                            title: 'Program Fidelity Dashboard'
                        }
                    },
                    {
                        path: 'scorecardKentucky',
                        loadComponent: () => import ('./views/scorecard-kentucky/scorecard-kentucky.component')
                            .then(m => m.ScorecardKentuckyComponent),
                        canActivate: [],
                        data: {
                            title: 'Agency Scorecard'
                        }
                    }
                ]
            },
            {
                path: 'form/:formId',
                loadComponent: () => import ('./views/form.component').then(m => m.FormComponent),
                canActivate: [],
                data: {
                    title: 'Form'
                }
            },
            {
                path: 'form/new/:clientId/:formType',
                loadComponent: () => import ('./views/form.component').then(m => m.FormComponent),
                canActivate: [],
                data: {
                    title: 'Form'
                }
            },
            {
                path: 'narrative/:includedAssessments/:clientId/:languageCode/:type/:hiddenIds',
                loadComponent: () => import ('./views/narrative.component').then(m => m.NarrativeComponent),
                canActivate: [],
                data: {
                    title: 'Narrative'
                }
            },
            {
                path: 'narrative/:includedAssessments/:clientId/:languageCode/:type',
                loadComponent: () => import ('./views/narrative.component').then(m => m.NarrativeComponent),
                canActivate: [],
                data: {
                    title: 'Narrative'
                }
            },
            {
                path: 'report',
                children: [
                    {
                        path: 'assessmentComparisonPrint',
                        loadComponent: () => import ('./views/reports/assessment-comparison-print.component')
                            .then(m => m.AssessmentComparisonPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Assessment Comparison Print'
                        }
                    },
                    {
                        path: 'assessmentPrint',
                        loadComponent: () => import ('./views/reports/assessment-print.component')
                            .then(m => m.AssessmentPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Assessment Print'
                        }
                    },
                    {
                        path: 'impactOutcomesPrint',
                        loadComponent: () => import ('./views/reports/impact-outcomes-print.component')
                            .then(m => m.ImpactOutcomesPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Assessment Print'
                        }
                    },
                    {
                        path: 'heatMapPrint',
                        loadComponent: () => import ('./views/reports/heat-map-print.component')
                            .then(m => m.HeatMapPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Heat Map Print'
                        }
                    },
                    {
                        path: 'impactDetailPrint',
                        loadComponent: () => import ('./views/reports/impact-detail-print.component')
                            .then(m => m.ImpactDetailPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Assessment Print'
                        }
                    },
                    {
                        path: 'impactPrint',
                        loadComponent: () => import ('./views/reports/impact-print.component')
                            .then(m => m.ImpactPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Assessment Print'
                        }
                    },
                    {
                        path: 'kentuckyAssessmentPrint',
                        loadComponent: () => import ('./views/reports/kentucky-assessment-print.component')
                            .then(m => m.KentuckyAssessmentPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Kentucky Assessment Print'
                        }
                    },
                    {
                        path: 'ticklerEpisodePrint',
                        loadComponent: () => import ('./views/reports/tickler-episode-print.component')
                            .then(m => m.TicklerEpisodePrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Tickler Episode Print'
                        }
                    },
                    {
                        path: 'ticklerTrackPrint',
                        loadComponent: () => import ('./views/reports/tickler-track-print.component')
                            .then(m => m.TicklerTrackPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Tickler Track Print'
                        }
                    },
                    {
                        path: 'expectedAssessmentsTrackPrint',
                        loadComponent: () => import ('./views/reports/expected-assessments-track-print.component')
                            .then(m => m.ExpectedAssessmentsTrackPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Expected Assessments Track Print'
                        }
                    },
                    {
                        path: 'expectedAssessmentsTrackDetailPrint',
                        loadComponent: () => import ('./views/reports/expected-assessments-track-detail-print.component')
                            .then(m => m.ExpectedAssessmentsTrackDetailPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Expected Assessments Track Detail Print'
                        }
                    },
                    {
                        path: 'assessmentEdePrint',
                        loadComponent: () => import('./views/reports/assessment-ede-print.component')
                            .then(m => m.AssessmentEdePrintComponent),
                        canActivate: [],
                        data: {
                            title: 'EDE-Q Assessment Print'
                        }
                    },
                    {
                        path: 'assessmentEdeqaPrint',
                        loadComponent: () => import('./views/reports/assessment-edeqa-print.component')
                            .then(m => m.AssessmentEdeqaPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'EDE-QA Assessment Print'
                        }
                    },
                    {
                        path: 'assessmentSbcCansPrint',
                        loadComponent: () => import('./views/reports/assessment-sbc-cans-print.component')
                            .then(m => m.AssessmentSbcCansPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'SB CANS Assessment Print'
                        }
                    },
                    {
                        path: 'approvalAggregatePrint',
                        loadComponent: () => import('./views/reports/approval-aggregate-print.component')
                            .then(m => m.ApprovalAggregatePrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Approval Aggregate Print'
                        }
                    },
                    {
                        path: 'approvalDetailPrint',
                        loadComponent: () => import('./views/reports/approval-detail-print.component')
                            .then(m => m.ApprovalDetailPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Approval Detail Print'
                        }
                    },
                    {
                        path: 'scorecardKentuckyPrint',
                        loadComponent: () => import('./views/reports/scorecard-kentucky-print.component')
                            .then(m => m.ScorecardKentuckyPrintComponent),
                        canActivate: [],
                        data: {
                            title: 'Agency Scorecard Print'
                        }
                    }
                ]
            },
        ]
    }
];
